import { render, staticRenderFns } from "./blockWord.vue?vue&type=template&id=f9d2e106&scoped=true&"
import script from "./blockWord.vue?vue&type=script&lang=js&"
export * from "./blockWord.vue?vue&type=script&lang=js&"
import style0 from "./blockWord.vue?vue&type=style&index=0&id=f9d2e106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d2e106",
  null
  
)

export default component.exports